import React from "react";

function EventKeywordField({ value, onChange, disabled, popup = false, required = false }) {

    if (popup) {
        return (
            <div className="oct-shared-popup__field">
                <label className="oct-shared-popup__label" htmlFor="event-keyword">
                    Event Keyword {required ? <span className="oct-shared-popup__required-mark">*</span> : null}
                </label>
                <input
                    className="oct-shared-popup__input"
                    id="event-keyword"
                    value={value}
                    autoComplete="off"
                    disabled={disabled}
                    placeholder="Enter keyword or regex pattern"
                    onChange={event => onChange && onChange(event.target.value)}
                />
            </div>
        )
    }

    return (
        <div className="oct_syslog-text-v2">
            <div>
                <h3 className="text-base font-bold text-slate-800 mb-1">Add Event Keyword</h3>
                <p className="text-xs text-slate-500 mb-0">Define a new keyword or RegEx pattern to identify events</p>
            </div>
            <input className="oct_settings-input-v2 w-100"
                id="event-keyword"
                value={value}
                autoComplete={"off"}
                disabled={disabled}
                placeholder="Enter keyword or regex pattern..."
                onChange={event => onChange(event.target.value)} />
        </div>
    )

}

export default EventKeywordField;
